import { CustomFormElementType } from './enums/custom-form-element-type.enum.js';
/**
 * The element types that render an authored placeholder (TM-9161).
 *
 * Deliberately an explicit pair rather than "the Eingabefeld family": if a third
 * text-ish sub-type ever joins that family it has to opt in here, instead of
 * inheriting a placeholder its renderer may not draw.
 *
 * Shared because the rule is enforced twice — the editor hides the "Platzhalter"
 * menu item, and the write path strips the value for every other type.
 */
const PLACEHOLDER_ELEMENT_TYPES = [
    CustomFormElementType.INPUT,
    CustomFormElementType.TEXTAREA,
];
export const supportsCustomFormPlaceholder = (type) => PLACEHOLDER_ELEMENT_TYPES.includes(type);
//# sourceMappingURL=custom-form-element-placeholder.js.map